"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const lodash_1 = __importDefault(require("lodash"));
const prop_types_1 = require("prop-types");
const react_1 = __importDefault(require("react"));
const colors_1 = require("../../utilities/colors");
function Bars(_ref) {
  let {
    bars = [],
    onMouseOver = () => {},
    onMouseOut = () => {},
    onClick = () => {}
  } = _ref;
  const posBars = bars.map((bar, i) => {
    const width = bar.width || 0;
    let x = bar.x || 0;
    if (width < 0) {
      x += width;
    }
    return {
      key: bar.key || i,
      width,
      height: bar.height || 0,
      x,
      y: bar.y || 0,
      color: colors_1.COLOR_PALETTE[bar.color] || bar.color || colors_1.DEFAULT_COLORS[0],
      opacity: 1,
      forceRedraw: lodash_1.default.uniqueId()
    };
  });
  return react_1.default.createElement("g", null, posBars.map((bar, i) => {
    const {
      key,
      x,
      y,
      width,
      height,
      color,
      opacity
    } = bar;
    return react_1.default.createElement("g", {
      key: key,
      onMouseOver: e => onMouseOver(e, i, bar),
      onMouseOut: e => onMouseOut(e, i, bar),
      onClick: e => onClick(e, i, bar)
    }, react_1.default.createElement("rect", {
      x: x,
      y: y,
      width: Math.abs(width),
      height: height,
      style: {
        fill: color,
        opacity
      }
    }));
  }));
}
Bars.propTypes = {
  /**
   * Bars to be drawn on the chart
   */
  bars: (0, prop_types_1.arrayOf)((0, prop_types_1.shape)({
    key: (0, prop_types_1.oneOfType)([prop_types_1.string, prop_types_1.number]),
    height: prop_types_1.number.isRequired,
    width: prop_types_1.number.isRequired,
    color: prop_types_1.string,
    x: prop_types_1.number,
    y: prop_types_1.number
  })).isRequired,
  /**
   * function to activate on click
   * parameters: (event, index, item)
   */
  onClick: prop_types_1.func,
  /**
   * function to activate on mouseOver
   * parameters: (event, index, item)
   */
  onMouseOver: prop_types_1.func,
  /**
   * function to activate on mouseOut
   * parameters: (event, index, item)
   */
  onMouseOut: prop_types_1.func
};
exports.default = Bars;